/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateSignedUploadUrlRequestFromJSON(json) {
    return StreemApiCreateSignedUploadUrlRequestFromJSONTyped(json, false);
}
export function StreemApiCreateSignedUploadUrlRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : json['type'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
    };
}
export function StreemApiCreateSignedUploadUrlRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'group': value.group,
        'sid': value.sid,
        'filename': value.filename,
        'company_code': value.companyCode,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiCreateSignedUploadUrlRequestType;
(function (StreemApiCreateSignedUploadUrlRequestType) {
    StreemApiCreateSignedUploadUrlRequestType["GPSPOSITION"] = "UPLOAD_TYPE_GPS_POSITION";
    StreemApiCreateSignedUploadUrlRequestType["LAYOUTESTIMATION"] = "UPLOAD_TYPE_LAYOUT_ESTIMATION";
    StreemApiCreateSignedUploadUrlRequestType["MESH"] = "UPLOAD_TYPE_MESH";
    StreemApiCreateSignedUploadUrlRequestType["RECORDING"] = "UPLOAD_TYPE_RECORDING";
    StreemApiCreateSignedUploadUrlRequestType["RECORDINGTRACK"] = "UPLOAD_TYPE_RECORDING_TRACK";
    StreemApiCreateSignedUploadUrlRequestType["ROOMNOTE"] = "UPLOAD_TYPE_ROOM_NOTE";
    StreemApiCreateSignedUploadUrlRequestType["SCENESHOT"] = "UPLOAD_TYPE_SCENESHOT";
    StreemApiCreateSignedUploadUrlRequestType["STREEMSHOT"] = "UPLOAD_TYPE_STREEMSHOT";
    StreemApiCreateSignedUploadUrlRequestType["STREEMSHOTNOTE"] = "UPLOAD_TYPE_STREEMSHOT_NOTE";
    StreemApiCreateSignedUploadUrlRequestType["TEXTUREDMESH"] = "UPLOAD_TYPE_TEXTURED_MESH";
    StreemApiCreateSignedUploadUrlRequestType["TRANSCRIPTION"] = "UPLOAD_TYPE_TRANSCRIPTION";
    StreemApiCreateSignedUploadUrlRequestType["UNKNOWN"] = "UPLOAD_TYPE_UNKNOWN";
})(StreemApiCreateSignedUploadUrlRequestType || (StreemApiCreateSignedUploadUrlRequestType = {}));
//# sourceMappingURL=StreemApiCreateSignedUploadUrlRequest.js.map